function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(-597 -174) translate(597 174)"
}, React.createElement("path", {
  fill: "#DFF0FC",
  d: "M162.924 112.041c-8.317 15.862-24.993 24.876-39.786 31.035-14.793 6.158-27.717 9.565-44.614 10.696-16.896 1.131-37.772 0-51.724-11.806-13.952-11.807-20.98-34.27-17.034-54.614C13.71 67.007 28.593 48.69 45.71 44.186c17.118-4.503 36.51 4.717 57.78 8.09 21.269 3.372 44.517.883 56.144 11.034 11.628 10.152 11.607 32.87 3.29 48.731z"
}), React.createElement("path", {
  fill: "#E6E6E6",
  d: "M47.2 173.917c-7.855-.69-15.917-1.014-23.055 1.649-1.959 1.096-3.973 4.903-.393 6.33 16.862 4.31 24.4 4.283 41.262 8.594 2.641.69 11.91 9.296 20.51 9.51 17.462-1.097 49.8-11.648 77.704-19.262 9.434-1.717-1.256-8.586-5.007-8.469l-53.718 1.586-57.303.062z"
}), React.createElement("path", {
  fill: "#F9A01B",
  d: "M92.814 128.738c22.876-27.393 8.683-39.545 8.683-39.545l-8.428-.055h-.076l-8.427-.055s-14.325 11.98 8.165 39.676v.103l.041-.055v.055l.042-.124z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#FFC906",
  d: "M22.774 84.921L40.278 84.921 40.278 90.59 22.774 90.59z",
  transform: "translate(62.069) rotate(-.4 31.526 87.756)"
}), React.createElement("path", {
  fill: "#FFC906",
  d: "M30.862 60.745C13.98 60.862.386 74.393.517 90.979c.025 3.738.763 7.436 2.173 10.897 4.655-11.59 15.855-19.217 28.346-19.302 12.49-.085 23.793 7.39 28.605 18.916 1.344-3.482 2.015-7.186 1.98-10.918-.124-16.593-13.904-29.944-30.759-29.827z",
  transform: "translate(62.069)"
}), React.createElement("path", {
  fill: "#F45F0B",
  d: "M11.876 51.103c.103 14.152 3.241 27.083 8.372 37.09 7.008-2.231 14.529-2.282 21.566-.145 4.98-10.076 7.93-23.048 7.827-37.2C49.49 30.214 42.89 12.166 33.09 2.014 32.383 1.288 31.41.882 30.398.89c-1.013.008-1.978.429-2.674 1.165-9.662 10.283-16 28.414-15.848 49.048z",
  transform: "translate(62.069)"
}), React.createElement("path", {
  fill: "#F4900B",
  d: "M16.566 21.317c-.545 1.483-1.249 4.028-1.249 4.028 3.338-1.414 16.435-5.559 29.862-2.242 0 0-.379-1.275-.69-1.972-5.055-4.807-20.958-6.338-27.923.186z",
  transform: "translate(62.069)"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M26.924 80.372c.07 9.345 1.773 17.428 4.207 21.38 2.372-3.993 3.966-12.097 3.897-21.449-.07-9.351-1.78-17.427-4.207-21.379-2.38 3.993-3.966 12.097-3.897 21.448z",
  transform: "translate(62.069)"
}), React.createElement("path", {
  fill: "#EFF4F9",
  d: "M31.02 101.566l.111.193c2.372-3.993 3.966-12.097 3.897-21.449-.07-9.351-1.78-17.427-4.207-21.379-.042.062-.076.138-.11.193l.31 42.442z",
  transform: "translate(62.069)"
}), React.createElement("path", {
  fill: "#FFC906",
  d: "M16.559 21.338c13.793-2.959 24.138-1.076 27.938-.207-2.931-7.952-6.98-14.648-11.76-19.469-.618-.629-1.465-.98-2.348-.974-.882.007-1.724.37-2.334 1.009-4.717 4.89-8.683 11.634-11.496 19.64zM31.372 32.786s-9.324.69-10.075 8.759c.034 4.476 4.772 7.207 9.33 7.234h.118c4.614-.034 7.82-4.207 7.786-8.745-.034-4.537-2.607-7.22-7.159-7.248z",
  transform: "translate(62.069)"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M30.634 34.331c-3.402.098-6.091 2.92-6.026 6.323.065 3.404 2.86 6.12 6.264 6.088 3.404-.032 6.147-2.8 6.149-6.204-.022-1.67-.708-3.264-1.906-4.428-1.198-1.165-2.81-1.805-4.48-1.779z",
  transform: "translate(62.069)"
})), React.createElement("path", {
  fill: "#2CA386",
  d: "M144.062 180.11l-51.724 2.007V121.91h53.186v56.759c0 .386-.155.756-.43 1.027-.274.27-.646.42-1.032.414z"
}), React.createElement("path", {
  fill: "#45CEA6",
  d: "M40.586 179.11l51.724 3.007V121.91H39.138v55.752c0 .384.153.753.424 1.024.272.272.64.424 1.024.424z"
}), React.createElement("path", {
  fill: "#2CA386",
  d: "M92.324 121.91H39.138l-11.952-13.655c-.373-.428-.461-1.034-.227-1.55.235-.517.75-.849 1.317-.85h47.993l16.055 16.055z"
}), React.createElement("path", {
  fill: "#45CEA6",
  d: "M92.324 121.91h53.186l11.952-13.655c.373-.428.462-1.034.227-1.55-.234-.517-.75-.849-1.317-.85H108.38L92.324 121.91z"
}), React.createElement("path", {
  fill: "#FFC906",
  d: "M12.11 165.807c-.018.178.034.356.145.496l4 4.925c.239.274.649.316.938.096.28-.237.326-.652.104-.945l-4-4.924c-.179-.193-.451-.268-.703-.193-.252.075-.44.286-.484.545z"
}), React.createElement("path", {
  fill: "#FFC906",
  d: "M11.641 170.269c-.014.177.04.352.152.49.237.276.647.321.938.103l4.931-4c.196-.254.191-.609-.011-.857-.202-.249-.55-.325-.837-.184l-4.924 4c-.138.112-.227.272-.249.448z"
}), React.createElement("circle", {
  cx: 27.193,
  cy: 81.89,
  r: 1.579,
  fill: "#4F94F7"
}), React.createElement("path", {
  fill: "#4F94F7",
  d: "M154.669 139.255c-.074.088-.11.203-.097.317l.428 4.104c.002.164.096.312.243.384.147.072.323.055.453-.043.13-.099.195-.263.166-.424l-.407-4.09c-.025-.237-.238-.41-.476-.386-.118 0-.23.05-.31.138z"
}), React.createElement("path", {
  fill: "#4F94F7",
  d: "M152.828 141.497c-.074.09-.11.207-.097.324.025.237.238.41.476.386l4.083-.407c.163-.002.312-.096.384-.243.072-.147.055-.323-.043-.453-.1-.13-.263-.195-.424-.166l-4.09.407c-.113.008-.218.063-.29.152z"
}), React.createElement("circle", {
  cx: 169.179,
  cy: 58.469,
  r: 2.421,
  fill: "#FFC906"
}), React.createElement("circle", {
  cx: 1.117,
  cy: 108.903,
  r: 1.117,
  fill: "#FFC906"
}), React.createElement("path", {
  fill: "#4F94F7",
  d: "M142.586 25.862c1.726-1.331 3.592-2.469 5.566-3.393l-1.055 7.241c-1.237-1.627-2.766-3.01-4.51-4.076"
}), React.createElement("path", {
  fill: "#F9A01B",
  d: "M141.931 70.497c2.552-2.476.359-4.325-1.455-2.635-6.062 5.662-10.835 15.697-15.69 42.269 6.566-31.124 17.11-39.628 17.145-39.634z"
}), React.createElement("path", {
  fill: "#4F94F7",
  d: "M29.69 33.2c-1.635-.193-3.286-.207-4.924-.041l3.49 4.31c.18-1.542.647-3.037 1.378-4.407"
}), React.createElement("path", {
  fill: "#FFC906",
  d: "M34.669 69.807c-2.862-1.745-1.22-3.91.8-2.759 6.765 3.966 13.248 12.221 23.234 35.71-12.51-27.296-24.02-32.944-24.034-32.951z"
}))));

var SvgBillingUpgradeToPro = function SvgBillingUpgradeToPro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 172,
    height: 200,
    viewBox: "0 0 172 200",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBillingUpgradeToPro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/billing-upgrade-to-pro.5c5ab302.svg";
export { ForwardRef as ReactComponent };